import PropTypes from 'prop-types';

import { LeadDataProvider } from './LeadDataContext';
import { LeadJobProvider } from './LeadJobContext';
import { LeadUIProvider } from './LeadUIContext';

/**
 * Root provider for the Lead Overview feature
 * Composes LeadDataProvider, LeadUIProvider, and LeadJobProvider
 *
 * Architecture:
 * - LeadDataContext: Queries, leads, contacts, pagination, AI analyses
 * - LeadUIContext: Selections, mutation actions
 * - LeadJobContext: Job progress, enrichment, job actions
 *
 * Note: Both LeadDataProvider and LeadJobProvider call useJobProgress internally.
 * This is fine because React Query caches the result, so there are no duplicate requests.
 */
export const LeadOverviewProvider = ({ children }) => {
	return (
		<LeadDataProvider>
			<LeadUIProvider>
				<LeadJobProvider>{children}</LeadJobProvider>
			</LeadUIProvider>
		</LeadDataProvider>
	);
};

LeadOverviewProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
